import { render, staticRenderFns } from "./bulma_p.vue?vue&type=template&id=82a50498"
import script from "./bulma_p.vue?vue&type=script&lang=js"
export * from "./bulma_p.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports